/**
 * API endpoints
 */
const ENDPOINTS = {
  v1: {
    permisos: 'v1/permisos',
    export: 'v1/export',
    obras: 'v1/obras',
    obrasMap: 'v1/obras/mapa',
    obrasList: 'v1/obras/lista',
    obrasFullDetails: 'v1/obras',
    maestros: 'v1/maestros',
    notificaciones: 'v1/notificaciones',
    dowloadPDF: 'v1/download',
  },
  admin: {
    assignmentCandidates: 'v1/admin/assignment-candidates',
    users: 'v1/admin/usuarios',
    noPhia: 'v1/admin/no_phia',
    general: 'v1/admin/general',
    permissions: 'v1/admin/permisos',
    permissionProjectLabels: 'v1/admin/permisos/project-labels',
    projects: 'v1/admin/proyectos'
  }
};

export default ENDPOINTS;
